import * as React from "react";
import { useTranslation } from "react-i18next";
import { usePagesContent } from "../../../../Hooks/usePagesContent";
import { useBatteryInfo } from "../../../../Pages/DigitalTwinV3/DigitalTwinContext";
import CustomIcon from "../../../../Components/CustomIcon";
import { Box } from "@mui/material";
import BatteryHealthDegradationChartSection from "../../components/BatteryHealthDegradationChartSection";



const BatteryHealthChartSection = ({ batteryID, selectedNode }) => {
    const { t } = useTranslation()

    const { batteryInfo } = useBatteryInfo()
    const pageContent = usePagesContent()

    const selectedPackIds = Array.isArray(selectedNode) ? selectedNode : [];
    const searchID     = selectedPackIds.length === 1 ? selectedPackIds[0] : batteryID;
    const searchColumn = selectedPackIds.length === 1 ? 'packConfigID' : 'batteryID';

    return (
        <Box className="battery-health-chart-section">
            <BatteryHealthDegradationChartSection
                pagesContent={pageContent?.metaInfo}
                deviceID={batteryInfo?.deviceID}
                cardStyle={{ marginLeft: "18px", marginBottom: "50px" }}
                cardSubTitle={t('degradation_curve_subtitle')}
                searchID={searchID}
                pageLabel="Digital Twin BatteryHealth"
                searchColumn={searchColumn}
                cardHeaderIcon={<CustomIcon name="degradation"></CustomIcon>}
            />
        </Box>
    )
}

export default BatteryHealthChartSection;